<template>
  <Layout>
    <b-row align-v="stretch">
      <b-col cols="4" class="mb-20">
        <b-card no-body class="mb-0">
          <b-card-header>
            <button class="btn btn-primary" v-if="roleAddable" :disabled="editingRole && editingRole.id" @click="addRole">{{ $t('page.role-management.add-role') }}</button>
            <div class="d-flex align-items-center mt-2" style="line-height: 1.5rem">
              <span class="me-2">{{ $t('page.role-management.current-role') }}：</span>
              <span class="text-primary me-2">{{ selecetRole ? (CAN_ROLE.includes(selecetRole.name)?$t(`page.role-management['${selecetRole.name}']`):selecetRole.name) : '' }}</span>
              <i v-if="selecetRole && selecetRole.name" class="ri-close-circle-line text-danger cursor-pointer" style="font-size: 1rem;" @click="cancelRoleSelect"></i>
            </div>
          </b-card-header>
          <b-card-body class="p-4">
            <div>
              <h4>{{ $t('page.role-management.role') }}</h4>
              <el-tree
                  ref="roleTree"
                  :data="roles"
                  :default-expand-all="true"
                  :expand-on-click-node="false"
                  node-key="id"
                  :empty-text="$t('page.role-management.no-role')"
                  :props="treeOptions"
                  :highlight-current="true"
                  v-click-outside="handleClickOutside"
                  @node-click="roleClick"
              >
                <template #default="{ node, data }">
                  <div class="flex-1">
                    <!--      编辑              -->
                    <div v-if="editingRole &&  editingRole.id === data.id">
                      <el-input
                          ref="roleInput"
                          v-model="editingRole.name"
                          @blur="updateRoleName(data, $event.target.value)"
                          @keyup.enter="$refs.roleInput.blur()"
                          @click.stop
                      />
                    </div>
                    <!--        非编辑状态            -->
                    <div v-else class="d-flex align-items-center">
                      <div class="flex-shrink-0">
                        {{ CAN_ROLE.includes(node.label)?$t(`page.role-management['${node.label}']`):node.label }}
                      </div>
                      <div class="flex-1 text-end fs-4" v-if="selecetRole && selecetRole.id === data.id">
                        <span v-if="roleEditable && data.can_edit !== false" class="ri-edit-2-line text-primary me-3" @click.stop="editRole(data)"></span>
                        <span v-if="roleDeletable && data.is_default !== true" class="ri-delete-bin-2-line text-danger me-2" @click.prevent="removeRole(data)"></span>
                      </div>
                    </div>
                  </div>
                </template>
              </el-tree>
            </div>
          </b-card-body>
          <b-card-footer class="d-flex justify-content-between" v-if="permissionEditable">
            <button ref="editPermissionBtn" v-if="!editingPermissions" class="btn btn-primary me-2" @click="editCurrentRolePermissions">{{ editPermissionBtnText }}</button>
            <button ref="savePermissionBtn" v-if="editingPermissions" class="btn btn-primary me-2 d-flex align-items-center" @click="saveCurrentRolePermissions">
              {{ savePermissionBtnText }}
              <span v-if="savePermissionLoading" class="spinner-border spinner-border-sm ms-1" role="status" aria-hidden="true"></span>
            </button>
            <button ref="delPermissionBtn" v-if="!editingPermissions" class="btn btn-light d-flex align-items-center" @click="delCurrentRolePermissions">
              {{ delPermissionBtnText }}
              <span v-if="delPermissionLoading" class="spinner-border spinner-border-sm ms-1" role="status" aria-hidden="true"></span>
            </button>
            <button ref="cancelPermissionEditBtn" v-if="editingPermissions" class="btn btn-light" @click="cancelPermissionsEdit">{{ cancelPermissionEditBtnText }}</button>
          </b-card-footer>
        </b-card>
      </b-col>
      <b-col cols="8" class="mb-20">
        <b-card no-body class="mb-0">
          <b-card-header>
            <h4>{{ $t('page.role-management.role-permissions') }}</h4>
          </b-card-header>
          <b-card-body v-loading="permissionLoading" class="p-4" data-simplebar data-simplebar-auto-hide="true" style="max-height: 900px; overflow-x: hidden;">
            <div class="accordion"  id="collapse-permission">
              <div class="accordion-item" v-for="(item, index) in permissionTree" :key="index">
                <h2 class="accordion-header" :id="'group-' + index">
<!--                  <button class="accordion-button" type="button" data-bs-toggle="collapse" :data-bs-target="'#collapse-' + index" aria-expanded="true" :aria-controls="'collapse-' + index">-->
                  <button class="accordion-button accordion-button-class fs-85" type="button" @click="collapsed[index] = !collapsed[index]">
                    <span @click.stop>
                      <b-form-checkbox v-model="item.checkAll" :disabled="!editingPermissions" @change="checkAllChildPermissions(item)" @click.stop></b-form-checkbox>
                    </span>
                    {{ $t(item.name) }}
                  </button>
                </h2>
                <div :id="'collapse-' + index" class="accordion-collapse" :class="{ collapse: true, show: !collapsed[index] }" :aria-labelledby="'group-' + index">
<!--                <div :id="'collapse-' + index" class="accordion-collapse collapse show" :aria-labelledby="'group-' + index" data-bs-parent="collapse-permission">-->
                  <div class="accordion-body">
                    <div v-for="(funcItem, funcIndex) in item.child" :key="funcIndex">
                      <div class="func-title mb-3 fw-bold fs-85">
                        {{ $t(funcItem.name) }}
                      </div>
                      <div class="permissions-list">
                          <span
                              v-for="(permissionItem, permissionIndex) in funcItem.child" :key="permissionIndex"
                              class="me-3 mb-3 px-2 py-2 badge fs-85"
                              :class="[permissionItem.active ? 'text-bg-success' : 'text-bg-light',
                                editingPermissions ? 'cursor-pointer' : ''
                              ]"
                              @click="clickPermission(permissionItem)"
                          >
                          {{ $t(permissionItem.name) }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import i18n from "@/i18n";
import { roleList, patchRole, deleteRole, postRole, getPermissionTree, patchRolePermission,
  getPartnerRoles, getPartnerPermissionTree, patchPartnerRolePermission } from "@/service";
import { ElMessageBox } from 'element-plus'
import { CAN_ROLE } from "@/config/common.js";
import { getLanguage } from "@/i18n";
const roleIdLimit = 99999
export default {
  components: {
    Layout,
  },
  data() {
    return {
      title: i18n.global.t("menu.system-management.role-management"),
      roles: [],
      treeOptions: {
        children: "sub",
        label: "name",
        class: "",
      },
      selecetRole: null,
      editingRole: null,
      roleBeforeEdit: null,
      editError: false, // 编辑遇到错误
      maxRoleId: roleIdLimit,
      parentRole: null,
      editingPermissions: false,
      editPermissionBtnText:  `${this.$t('base.edit')}-${this.$t('base.permission')}`,
      savePermissionBtnText:  `${this.$t('base.confirm')}-${this.$t('base.permission')}`,
      delPermissionBtnText:  `${this.$t('base.delete')}-${this.$t('base.permission')}`,
      cancelPermissionEditBtnText:  `${this.$t('base.cancel')}${this.$t('base.edit')}`,
      savePermissionLoading: false,
      delPermissionLoading: false,
      permissionLoading: false,
      permissionTree: [],
      collapsed: {},
      roleNameUpdating: false,
      type: null,
      CAN_ROLE,//["代理商","工程师","基本用户","客户","设备联系人","管理员"]
    };
  },
  mounted() {
    this.refresh()
  },
  computed: {
    // 获取根节点的ID
    rootRoleId() {
      if (this.roles.length > 0) {
        return this.roles[0].id
      }
      return null
    },
    // 角色是否可编辑
    roleEditable() {
      if (this.type != 'role') {
        return false
      }
      // 判断是否有编辑权限
      return this.hasPermissionFor('management.role.patch');

    },
    // 角色是否可添加
    roleAddable() {
      if (this.type != 'role') {
        return false
      }
      // 判断是否有添加权限
      return this.hasPermissionFor('management.role.post');

    },
    // 角色是否可删除
    roleDeletable() {
      if (this.type != 'role') {
        return false
      }
      // 判断是否有删除权限
      return this.hasPermissionFor('management.role.delete');

    },
    // 是否可编辑权限
    permissionEditable() {
      if (this.type === 'role') {
        // 不能编辑自己的权限，即根节点不允许编辑权限
        if (this.selecetRole && this.selecetRole.id === this.rootRoleId) {
          return false
        }
        return true
      }
      // 商业伙伴过来的判断是否有权限
      return this.hasPermissionFor('admin.permission.post');

    },
    getPermissionTreeFunc() {
      if (this.type === 'role') {
        return getPermissionTree
      }
      return getPartnerPermissionTree
    },
    patchRolePermissionFunc() {
      if (this.type === 'role') {
        return patchRolePermission
      }
      return patchPartnerRolePermission
    },
  },
  methods: {
    refresh() {
      this.selecetRole = null
      this.editingRole = null
      this.roleBeforeEdit = null
      this.parentRole = null
      this.editingPermissions = false
      this.savePermissionLoading = false
      this.delPermissionLoading = false
      this.permissionLoading = false
      this.permissionTree = []
      this.collapsed = {}
      this.type = this.$route.query.type ? this.$route.query.type : 'role'
      this.getRoleList()
    },
    getRoleList() {
      if (this.type === 'role') {
        roleList().then((res) => {
          this.roles = res.payload;
        });
        return
      }
      getPartnerRoles(this.type).then((res) => {
        this.roles = res.payload;
        this.setCurrentRole(this.roles[0])
        this.$nextTick(() => {
          this.$refs.roleTree.setCurrentKey(this.roles[0].id);
        })
      });
    },
    handleClickOutside() {
      this.$nextTick(() => {
        if (this.selecetRole) {
          this.setCurrentRole(this.selecetRole)
        }
      });
    },
    roleClick(role) {
      if (!role) {
        console.log('roleClick:没有role')
        return
      }
      this.editingRole = null
      this.setCurrentRole(role)
    },
    // 设置当前角色为指定角色
    setCurrentRole(role) {
      if (!role) {
        console.log('setCurrentRole:没有role')
        return
      }
      this.selecetRole = {...role}
      this.$refs.roleTree.setCurrentKey(this.selecetRole.id);
      const lang = getLanguage()
      let en_txt = CAN_ROLE.includes(role.name)?this.$t(`page.role-management['${role.name}']`):role.name
      if(lang == "ch"){
        this.editPermissionBtnText = `${this.$t('base.edit')}${role.name}${this.$t('base.permission')}`
        this.savePermissionBtnText = `${this.$t('base.confirm')}${role.name}${this.$t('base.permission')}`
        this.delPermissionBtnText = `${this.$t('base.delete')}${role.name}${this.$t('base.permission')}` 
      }else{
        this.editPermissionBtnText = `${this.$t('base.edit')} ${en_txt} ${this.$t('base.permission')}`
        this.savePermissionBtnText = `${this.$t('base.confirm')} ${en_txt} ${this.$t('base.permission')}`
        this.delPermissionBtnText = `${this.$t('base.delete')} ${en_txt} ${this.$t('base.permission')}`
      }

    },
    cancelRoleSelect() {
      if (this.selecetRole.id >= roleIdLimit) {
        this.$refs.roleTree.remove(this.selecetRole.id)
      }
      this.selecetRole = null
      this.$refs.roleTree.setCurrentKey(null);

      this.editPermissionBtnText = `${this.$t('base.edit')}-${this.$t('base.permission')}`
      this.savePermissionBtnText = `${this.$t('base.confirm')}-${this.$t('base.permission')}`
      this.delPermissionBtnText = `${this.$t('base.delete')}-${this.$t('base.permission')}`
      this.editingPermissions = false
    },
    addRole() {
      // 加限制：必须要选了角色后，才让添加，否则提示选择角色
      if (!this.selecetRole) {
        this.$message({
          type: "warning",
          message: this.$t("page.role-management.please-select-role"),
        });
        return
      }
      let roleName = this.$t("page.role-management.new-role");
      let counter = 2;
      while (this.isRoleNameExists(roleName)) {
        roleName = `${this.$t("page.role-management.new-role")}${counter}`;
        counter++;
      }
      const newRole = {
        id: ++this.maxRoleId,
        name: roleName,
        sub: [],
        is_default: false,
        can_edit: true
      };
      this.parentRole = this.selecetRole ? {...this.selecetRole} : null
      if (this.parentRole) {
        this.$refs.roleTree.append(newRole, this.parentRole);
      } else {
        this.roles.push(newRole);
      }
      this.$nextTick(() => {
        this.setCurrentRole(newRole);
        this.editRole(newRole);
      });
    },

    // 设置当前编辑的角色
    editRole(role) {
      this.editingRole = role
      this.roleBeforeEdit = {...role}
      this.editError = false
      this.$nextTick(() => {
        this.$refs.roleInput.focus();
      });
    },
    // 更新角色名称:保存更新
    updateRoleName(role, newName) {
      if (this.roleNameUpdating) {
        return;
      }
      if (!newName) {
        if (role.id >= roleIdLimit) {
          this.$message.error(this.$t('page.role-management.Please set the name for the new role'))
        }
        role.name = this.roleBeforeEdit.name
        this.editingRole = null
        return;
      }
      if (newName === this.roleBeforeEdit.name) {
        if (role.id >= roleIdLimit) {
          this.$message.error(this.$t('page.role-management.Please set the name for the new role'))
        }
        this.editingRole = null
        return;
      }
      this.roleNameUpdating = true;

      if (role.id >= roleIdLimit) {
        postRole({ name: role.name, parent_id: this.parentRole ? this.parentRole.id : null, display_name: role.name }).then((res) => {
          const roleRes = res.payload;
          const newRole = {
            id: roleRes.id,
            name: roleRes.display_name,
            sub: [],
          };
          this.roleNameUpdating = false;
          // 删除旧角色，添加新角色，更新当前角色
          this.$refs.roleTree.remove(role.id)
          this.$refs.roleTree.append(newRole, this.parentRole ? this.parentRole.id : null);
          this.setCurrentRole(newRole)
          this.editingRole = null
          this.$message.success(this.$t('page.role-management.New role added successfully!'))
        }).catch((err) => {
          console.log('新增角色失败：', err)
          this.roleNameUpdating = false;
        })
      } else {
        // console.log('调接口更新角色:', role)
        patchRole({id: role.id, display_name: role.name}).then(() => {
          this.roleNameUpdating = false;
          this.editingRole = null
          this.$message.success(this.$t('page.role-management.Role name updated successfully!'))
        }).catch(() => {
          this.roleNameUpdating = false;
          this.editError = true
        })
      }
    },
    removeRole(role) {
      console.log(role)
      if (role.id >= roleIdLimit) {
        this.cancelRoleSelect()
        // remove方法也会从更新roles变量
        this.$refs.roleTree.remove(role)
        this.$message({
          type: "success",
          message: this.$t('base.delete_success'),
        });
        return
      }

      ElMessageBox.confirm(this.$t('page.role-management.Delete this role?'),this.$t('base.prompt'),{
        confirmButtonText: this.$t('base.confirm'),
        cancelButtonText: this.$t('base.cancel'),
        type: "warning",
      })
          .then(() => {
            // 判断是否有下级角色，有下级角色不可删除
            if (role.sub && role.sub.length > 0) {
              this.$message({
                type: "error",
                message: this.$t('page.role-management.Please delete the sub-roles first!')
              });
              return;
            }
            // 调接口删除角色
            deleteRole(role.id).then(() => {
              this.cancelRoleSelect()
              // remove方法也会从更新roles变量
              this.$refs.roleTree.remove(role)
              this.$message({
                type: "success",
                message: this.$t('base.delete_success'),
              });
            }).catch((err) => {
              console.log('删除失败',err)
            })

          })
          .catch(() => {
            // this.$message({
            //   type: "info",
            //   message: "已取消删除",
            // });
          });
    },
    isRoleNameExists(name, rolesList = this.roles) {
      for (let role of rolesList) {
        if (role.name === name) {
          return true;
        }
        if (role.sub && role.sub.length > 0) {
          if (this.isRoleNameExists(name, role.sub)) {
            return true;
          }
        }
      }
      return false;
    },
    editCurrentRolePermissions() {
      if (!this.selecetRole) {
        this.$message.error(this.$t('page.role-management.Please select the role you want to operate on!'))
        return;
      }
      if (this.selecetRole.id === this.maxRoleId) {
        this.$message.error(this.$t('page.role-management.Please save the newly created role first!'))
        return;
      }
      this.editingPermissions = true
    },
    cancelPermissionsEdit() {
      this.editingPermissions = false
      this.getPermissions()
    },
    saveCurrentRolePermissions() {
      if (this.savePermissionLoading) {
        return;
      }
      if (!this.selecetRole) {
        this.$message.error(this.$t('page.role-management.Please select the role you want to operate on!'))
        return;
      }
      if (this.selecetRole.id >= roleIdLimit) {
        this.$message.error(this.$t('page.role-management.Invalid role'))
        return;
      }
      this.savePermissionLoading = true
      const codes = this.getActiveCodes(this.permissionTree)
      // console.log('当前角色的权限：', codes)
      // 调接口更新角色权限
      this.patchRolePermissionFunc({role_id: this.selecetRole.id, permissions: codes}).then(() => {
        this.savePermissionLoading = false
        this.editingPermissions = false
        this.$message.success(this.$t('page.role-management.Role permissions updated successfully!'))
      }).catch(() => {
        this.savePermissionLoading = false
        this.editingPermissions = false
      })
    },
    delCurrentRolePermissions() {
      if (this.delPermissionLoading) {
        return;
      }
      if (!this.selecetRole) {
        this.$message.error(this.$t('page.role-management.Please select the role you want to operate on!'))
        return;
      }
      if (this.selecetRole.id >= roleIdLimit) {
        this.$message.error(this.$t('page.role-management.Invalid role'))
        return;
      }
      ElMessageBox.confirm(this.$t('page.role-management.Delete all permissions of this role?'),this.$t('base.prompt'),{
        confirmButtonText: this.$t('base.confirm'),
        cancelButtonText: this.$t('base.cancel'),
        type: "warning",
      }).then(() => {
        // 调接口删除角色权限
        this.delPermissionLoading = true
        patchRolePermission({role_id: this.selecetRole.id, permissions: []}).then(() => {
          this.delPermissionLoading = false
          this.$message.success(this.$t('page.role-management.Role permissions deleted successfully!'))
          this.getPermissions()
        }).catch(() => {
          this.delPermissionLoading = false
        })
      }).catch(() => {
        // this.$message({
        //   type: "info",
        //   message: "已取消删除",
        // })
      })
    },
    clickPermission(item) {
      if (!this.editingPermissions) {
        return;
      }
      item.active = !item.active
    },
    checkAllChildPermissions(item) {
      item.child.forEach((c => {
        c.child.forEach(p => {
          p.active = item.checkAll
        })
      }))
    },
    getPermissions() {
      if (!this.selecetRole || !this.selecetRole.id || this.selecetRole.id >= roleIdLimit) {
        this.permissionTree = []
        return;
      }
      this.permissionLoading = true
      this.getPermissionTreeFunc(this.selecetRole.id).then(res => {
        const complete_tree = res.payload.permission_tree
        const active_permissions = res.payload.role_permissions
        this.permissionTree = this.processPermissionTree(complete_tree, active_permissions)
        this.permissionLoading = false
      }).catch(err => {
        console.log(err)
      })
    },
    processPermissionTree(permission_tree, active_permissions) {
      return permission_tree.map((item) => {
        const newItem = { ...item };

        if (item.sub) {
          newItem.child = this.processPermissionTree(item.sub, active_permissions);

          newItem.checkAll = newItem.child.every((child) =>
              child.child ? child.child.every((subChild) => subChild.active) : child.active
          );
        }

        if (item.code) {
          newItem.code = item.code;
          newItem.active = active_permissions.includes(item.code);
        }

        return newItem;
      });
    },
    getActiveCodes(tree) {
      let activeCodes = [];

      tree.forEach((item) => {
        if (item.child) {
          activeCodes = activeCodes.concat(this.getActiveCodes(item.child));
        } else if (item.active && item.id) {
          activeCodes.push(item.id);
        }
      });
      return activeCodes;
    },
  },
  watch: {
    'selecetRole.id': 'getPermissions',
    $route:{
      handler:'refresh',
    }
  },
};
</script>
<style lang="scss" scoped>
.el-tree-node__content {
  height: 36px;
}
.customTreeClass {
  background-color: #f5f7fa;
}
.fs-85 {
  font-size: 0.85rem!important;
}
.mb-20 {
  margin-bottom: 20px!important;
}

</style>

